import common from "../common";
import BaseStage from "./BaseStage";
import TutorialFinger from "../reusableModules/TutorialFinger";
import Decoration from "../reusableModules/Decoration";
import Dough from "./Stage_Cutting_Objects/Dough";

/**
 * Decorating the dough
 */
export default class Stage_Decoration extends BaseStage {
    constructor() {
        super("decorate_1");
        this.bindings = {};

        this._allCookies = [];
        this._selectedCookie = null;
        this._decorationMenu = null;
        this._selectedDecoration = null;

        this._cookieMask = common.cutCookieTextures != null ? common.cutCookieTextures.maskTexture : P3.assets.texture("mask_dough_shape_1");
        this._selectedCookieShape = common.cutCookieTextures != null ? common.cutCookieTextures.shapeTexture : P3.assets.texture("dough_shape_1");

        this._cookieInformation = {
            mask: this._cookieMask,
            shape: P3.assets.texture(this.switchCookieTexture(this._selectedCookieShape.textureCacheIds[0])),
            scale: 1,
            children: []
        };
        common.finishedRecipe = this._cookieInformation;
        this._tutorialFinger = null;

        this._request = null;
        this._requestCounter = null;
        this._requestMap = null;
        this._requestTracker = {};

        this._decoration = null;
    }

    init() {
        super.init(P3.audio.playMusic("music_ambient_music_loop_00"));

        let bk = new PIXI.Sprite(P3.assets.texture('bg_table'));
        bk.anchor.set(0.5);
        bk.width = 1900;
        bk.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChild(bk);

        this._request = common.selectedCharacter.getRequest();
        this._requestCounter = this._request.requestedParts.length;
        this._requestMap = new Map();
        this._requestMap.set("dec_mm_001", "deco_mms");
        this._requestMap.set("dec_mm_002", "deco_mms");
        this._requestMap.set("dec_mm_003", "deco_mms");
        this._requestMap.set("dec_mm_004", "deco_mms");

        this._requestMap.set("dec_sugar_001", "deco_iced_sugar");
        this._requestMap.set("dec_sugar_002", "deco_iced_sugar");

        this._requestMap.set("dec_sprinkle_001", "deco_sprinkles");
        this._requestMap.set("dec_sprinkle_002", "deco_sprinkles");
        this._requestMap.set("dec_sprinkle_003", "deco_sprinkles");
        this._requestMap.set("dec_sprinkle_004", "deco_sprinkles");

        this._requestMap.set("dec_heart_001", "deco_candies");
        this._requestMap.set("dec_heart_002", "deco_candies");
        this._requestMap.set("dec_heart_003", "deco_candies");
        this._requestMap.set("dec_heart_004", "deco_candies");

        this._requestMap.set("dec_choc_001", "deco_chocolate");
        this._requestMap.set("dec_choc_002", "deco_chocolate");
        this._requestMap.set("dec_choc_003", "deco_chocolate");
        this._requestMap.set("dec_choc_004", "deco_chocolate");


        this.createCookie();
        this.createDecorationMenu();
        this.createUI();
        //this.clickingTutorialAnimation();

        this.bindings.help = this.signals.helpTutorial.add(()=>{
            this.clickingTutorialAnimation();
        }, this);
    }

    destroy() {
        for (const i in this.bindings) {
            if (this.bindings.hasOwnProperty(i)) {
                const binding = this.bindings[i];
                binding.detach();
            }
        }
        this.bindings = {};

        super.destroy();
    }

    resize() {
        super.resize();
        this._nextStageButton.x = (common.STAGE_WIDTH + P3.View.width) * 0.5 - 225;
        this._nextStageButton.y = common.STAGE_HEIGHT * 0.5 + 275;
    }

    animateIn() {
        super.animateIn();
        this.onStageComplete();
    }

    update() {
        super.update();
        if (this._tutorialFinger != null)
            this._tutorialFinger.update();
    }

    pauseGame() {
        super.pauseGame();
    }

    resumeGame() {
        super.resumeGame();
    }

    createDecorationMenu() {
        let centre = {x: common.STAGE_WIDTH * 0.5, y: common.STAGE_HEIGHT * 0.5};
        let decorationPositions = [
            {x: centre.x - 340, y: centre.y - 200},
            {x: centre.x + 340, y: centre.y - 100},
            {x: centre.x - 390, y: centre.y},
            {x: centre.x - 340, y: centre.y + 200},
            {x: centre.x + 340, y: centre.y + 100},
        ];

        this._decorationMenu = new PIXI.Container();
        this._decorationMenu._decorations = [];


        this._decorationMenu.selectSprite = new PIXI.Sprite(P3.assets.texture('deco_selected'));
        this._decorationMenu.selectSprite.anchor.set(0.5);
        this._decorationMenu.selectSprite.visible = false;
        this.addChildAt(this._decorationMenu.selectSprite,4);

        let newTween = (object, position)=>{
            return new P3.utils.TWEEN.Tween(object, this.tweens)
                .to({
                    x: position.x,
                    y: position.y
                }, common.getRandomInt(1000, 2000))
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .start();
        };


        for (let i = 0; i < common.selectedRecipeBuild.decorationTextures[0].group.length; i++) {
            let states = new P3.ButtonStates();
            states.normal = P3.assets.texture(common.selectedRecipeBuild.decorationTextures[0].group[i]);

            let button = new P3.Button(states);
            button.x = decorationPositions[i].x > centre.x ? common.STAGE_WIDTH + 600 : 0 - 600;
            button.y = decorationPositions[i].y;
            button._individualTextures = [];
            button.signals.down.add(this.onButtonClick, this);
            this.addChild(button);
            button._tween = newTween(button, decorationPositions[i]);

            for (let j = 0; j < common.selectedRecipeBuild.decorationTextures[0].individual[i].length; j++) {
                const individualElementElement = common.selectedRecipeBuild.decorationTextures[0].individual[i][j];
                button._individualTextures.push(P3.assets.texture(individualElementElement));
            }
            this._decorationMenu._decorations.push(button);
            this.addChild(button);
        }
        this._decorationMenu._decorations[0]._tween.onComplete(()=>{
            this.clickingTutorialAnimation();
        });
        this.addChild(this._decorationMenu);
    }

    onButtonClick(button){
        if(this._decoration != null){
            this.removeChild(this._decoration);
            this._decoration.destroy();
            this._decoration = null;
        }

        this._decorationMenu.selectSprite.visible = true;
        this._decorationMenu.selectSprite.position.set(button.x, button.y);

        this._decoration = new Decoration(button._individualTextures);
        this._decoration._lastSpawnPosition = {x:0, y:0};
        this._decoration._isFollowing = false;
        P3.audio.playSound("sfx_btn_accept_00");
        this._tutorialFinger.turnOff();
    }

    addDecoration(decoration){
        let newDecoration = new PIXI.Sprite(decoration._curTexture);
        newDecoration.x = decoration.x - this.testContainer.x;
        newDecoration.y = decoration.y - this.testContainer.y;
        newDecoration.anchor.set(0.5);
        this.cookieContaier.addChild(newDecoration);

        this._cookieInformation.children.push({
            texture: decoration._curTexture,
            scale: 1,
            position: {x: newDecoration.x, y: newDecoration.y}
        });

        if(!this._decSound){
            let sounds = ['sfx_add_splodge_00'];
            this._decSound = P3.audio.playSound(common.randomSelection(sounds),{
                destroyOnComplete: true,
                callback: ()=>{
                    this._decSound = null;
                }
            });
        }
    }

    createCookie() {
        let backgroundCloth = new PIXI.Sprite(P3.assets.texture('tablecloth'));
        backgroundCloth.scale.set(1);
        backgroundCloth.anchor.set(0.5);
        backgroundCloth.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChild(backgroundCloth);


        let bgCookie = new PIXI.Sprite(P3.assets.texture(this.switchCookieTexture(this._selectedCookieShape.textureCacheIds[0])));
        bgCookie.anchor.set(0.5);
        bgCookie.scale.set(.9);
        bgCookie.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChild(bgCookie);

        this.testContainer = new PIXI.Container();
        this.testContainer.position.set(common.STAGE_WIDTH * 0.5, common.STAGE_HEIGHT * 0.5);
        this.addChild(this.testContainer);


        this.cookieContaier = new PIXI.Container();
        this.testContainer.addChild(this.cookieContaier);

        let cookie = new PIXI.Sprite(P3.assets.texture(this.switchCookieTexture(this._selectedCookieShape.textureCacheIds[0])));
        cookie.anchor.set(0.5);
        cookie.scale.set(1);
        this._selectedCookie = cookie;
        this.cookieContaier.addChild(cookie);

        if(common.doughIngredient){

            let determineIng = ()=>{
                let colour = common.doughIngredient;
                //console.log(colour);
                let map = new Map();
                map.set('ing_white_choc', Dough.WHITE);
                map.set('ing_dark_choc', Dough.DARK);
                map.set('ing_rasins', Dough.RAISEN);
                map.set('ing_strawberries', Dough.STRAWBERRY);

                let col = null;
                map.forEach((v,k) => {
                    if(v === colour.toString()){
                        col = k;
                    }
                });
                return col;
            };
            const ingOverlay = new PIXI.Sprite(P3.assets.texture(determineIng() + "_cookie_texture"));
            ingOverlay.anchor.set(0.5);
            ingOverlay.scale.set(0.8);
            this.cookieContaier.addChild(ingOverlay);
        }



        let cookieMask = new PIXI.Sprite(this._cookieMask);
        cookieMask.anchor.set(0.5);
        cookieMask.width = cookie.width - 25;
        cookieMask.height = cookie.height - 30;
        this.testContainer.addChild(cookieMask);

        this.cookieContaier.mask = cookieMask;

        this.doughDimensions = {
            x: this.testContainer.x - this.testContainer.width * 0.5,
            y: this.testContainer.y - this.testContainer.height * 0.5,
            h: this.testContainer.height,
            w: this.testContainer.width
        };

        this.cookieContaier.interactive = true;
        this.cookieContaier.on('touchstart', this.testMouseDown, this);
        this.cookieContaier.on('mousedown', this.testMouseDown, this);

        this.cookieContaier.on('touchmove', this.testMouseMove, this);
        this.cookieContaier.on('mousemove', this.testMouseMove, this);

        this.cookieContaier.on('touchend', this.testMouseUp, this);
        this.cookieContaier.on('mouseup', this.testMouseUp, this);
        this.cookieContaier.on('touchendoutside', this.testMouseUp, this);
        this.cookieContaier.on('mouseupoutside', this.testMouseUp, this);
    }

    switchCookieTexture(texture) {
        let str = texture.replace("dough", "cookie");
        return str.slice(0, -4);
    }

    clickingTutorialAnimation() {
        if(this._tutorialFinger != null){
            this.removeChild(this._tutorialFinger);
            this._tutorialFinger.destroy();
            this._tutorialFinger = null;
        }

        this._tutorialFinger = new TutorialFinger({
            x: this._decorationMenu._decorations[0].x + 75,
            y: this._decorationMenu._decorations[0].y
        }, 10, -1);
        this.addChild(this._tutorialFinger);

        this._tutorialFinger.fade(true, 500, false);

        this._tutorialFinger.clickDown();
        this._tutorialFinger.clickUp();

        this._tutorialFinger.addStep(new P3.utils.TWEEN.Tween(this._tutorialFinger._view, this.tweens)
            .to({
                x: common.STAGE_WIDTH * 0.5 + 75,
                y: common.STAGE_HEIGHT * 0.5
            }, 1000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut));

        this._tutorialFinger.clickDown();
        this._tutorialFinger.clickUp();

        this._tutorialFinger.addStep(new P3.utils.TWEEN.Tween(this._tutorialFinger._view, this.tweens)
            .to({
                x: common.STAGE_WIDTH * 0.5 - 75,
                y: common.STAGE_HEIGHT * 0.5 - 50
            }, 1000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut));

        this._tutorialFinger.clickDown();
        this._tutorialFinger.clickUp();

        this._tutorialFinger.addStep(new P3.utils.TWEEN.Tween(this._tutorialFinger._view, this.tweens)
            .to({
                x: common.STAGE_WIDTH * 0.5 + 75,
                y: common.STAGE_HEIGHT * 0.5 + 120
            }, 1000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut));

        this._tutorialFinger.clickDown();
        this._tutorialFinger.clickUp();
        this._tutorialFinger.fade(false, 500, false);
        this._tutorialFinger.addDelay(1000);
        this._tutorialFinger.play();
    }

    testMouseDown(event){
        if(this._decoration == null) return;
        this._tutorialFinger.turnOff();

        let newPos = event.data.getLocalPosition(this);
        this._decoration.x = newPos.x;
        this._decoration.y = newPos.y;


        this.addDecoration(this._decoration);

        this._decoration._lastSpawnPosition = {
            x: this._decoration.x,
            y: this._decoration.y,
            r: this._decoration._curTexture.width * 0.5
        };

        this._decoration.randomiseTexture();
        this._decoration._isFollowing = true;
    }

    testMouseMove(event){
        if(this._decoration === null) return;
        let newPos = event.data.getLocalPosition(this);
        this._decoration.x = newPos.x;
        this._decoration.y = newPos.y;

        if(this._decoration._isFollowing === true){

            if(this._decoration._lastSpawnPosition != null)
                if(!this.testCheckOverlap(this._decoration._lastSpawnPosition, {
                    x: this._decoration.x,
                    y: this._decoration.y,
                    r: this._decoration._curTexture.width * 0.45
                })){
                    this.addDecoration(this._decoration);
                    this._decoration._lastSpawnPosition = {
                        x: this._decoration.x,
                        y: this._decoration.y,
                        r: this._decoration._curTexture.width * 0.45
                    };
                    this._decoration.randomiseTexture();
                }
        }
    }

    testMouseUp(){
        if(this._decoration == null) return;
        this._decoration._isFollowing = false;
    }

    testCheckOverlap(a, b){
        let deltaXSquared = a.x - b.x;
        deltaXSquared *= deltaXSquared;
        let deltaYSquared = a.y - b.y;
        deltaYSquared *= deltaYSquared;

        let sumRadiiSquared = a.r + b.r;
        sumRadiiSquared *= sumRadiiSquared;

        return deltaXSquared + deltaYSquared <= sumRadiiSquared;
    }
}